module.exports = __webpack_public_path__ + "img/cover.60da4bd4.jpg";